"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.useReviewIdByDeepLinks = exports.deleteWithConfirmation = exports.isJde = exports.handleGoToFolder = exports.handleDownloadFile = exports.handleOpenFile = exports.getPriorityDataSubmission = exports.handleDeleteFile = exports.handleDesktopEdit = exports.handleOpenInOfficeOnline = exports.handleCopyFile = exports.handleCheckout = exports.handleEnablePublicLink = exports.handleApproveFileForRelease = exports.handleApproveFile = exports.handleAddToCollection = exports.handleUploadNewVersion = exports.getAssetStatusColor = exports.buildAssetPdfPreviewUrl = exports.parseAssetDetailResponse = exports.getAssetDetailResponse = exports.handleUploadAttachment = exports.handleRequestAPI = exports.notesMapper = exports.getAssetDetailParams = exports.JDE_BRAND_CATEGORY_ID = exports.PRIORITY_DEESCALATED = exports.PRIORITY_ESCALATED = exports.PRIORITY = exports.WEBSOCKET_CONFIG = exports.CONFIG = exports.CURRENT_USER = exports.JOB_ID = exports.URLS = void 0;
/* eslint-disable camelcase */
/* eslint-disable no-undef */
const moment_1 = __importDefault(require("moment"));
const utilities_1 = __importStar(require("jsAssets/utilities"));
const lodash_1 = require("lodash");
const jquery_1 = __importDefault(require("jquery"));
exports.URLS = window.pulse.config.urls;
exports.JOB_ID = (_b = (_a = window === null || window === void 0 ? void 0 : window.pulse) === null || _a === void 0 ? void 0 : _a.request) === null || _b === void 0 ? void 0 : _b.jobId;
exports.CURRENT_USER = window.pulse.config.user;
exports.CONFIG = window.pulse.config;
exports.WEBSOCKET_CONFIG = exports.CONFIG.ws;
var PRIORITY;
(function (PRIORITY) {
    PRIORITY[PRIORITY["escalated"] = 126] = "escalated";
    PRIORITY[PRIORITY["deescalated"] = 125] = "deescalated";
})(PRIORITY = exports.PRIORITY || (exports.PRIORITY = {}));
exports.PRIORITY_ESCALATED = 126;
exports.PRIORITY_DEESCALATED = 125;
exports.JDE_BRAND_CATEGORY_ID = 346;
const getAssetDetailParams = (ticketId) => {
    const includeFields = [
        'requirement',
        'requirement.job',
        'requirement.job.client',
        'requirement.job.brand',
        'requirement.job.airing-country',
        'requirement.directory',
        'invoice',
        'asset-workflow-approvals',
        'requirement.job.brand.category',
        'asset-workflow-approvals.user',
        'invoice.author',
        'invoice.invoice-rule',
        'invoice.invoice-tax-rate',
        'note.ticket.workflow',
        'note.ticket.workflow-rule',
        'note.ticket.users',
        'note.ticket.groups',
        'note.ticket.groups.users',
        'note.ticket.predecessor',
        'note.ticket.parent',
        'note.ticket.type',
        'note.ticket.ticketStatus',
        'note.ticket.tags',
        'notes',
        'notes.ticket',
        'asset-detail',
        'asset-detail.language',
        'asset-detail.format',
        'asset-detail.program',
        'asset-detail.category',
        'asset-detail.media-channel',
        'doc-type',
        'asset-meta-data',
        'generated-preview-pdf',
        'tags',
        'uploaded-by',
        'airing-country',
        'campaign',
    ];
    if (!ticketId) {
        return {
            include: includeFields.join(','),
        };
    }
    return {
        include: includeFields.join(','),
        filter: {
            'note.ticket.ticketid': ticketId,
        },
    };
};
exports.getAssetDetailParams = getAssetDetailParams;
/**
 * @description Map API notes to correct comments format
 * @param {array} notes
 * @returns {array} comments
 */
const notesMapper = (notes) => {
    return notes.map((note) => ({
        ...note,
        id: note.noteId,
        date: note.date,
        assets: note.attachments,
        childTaskNotes: note.childNotes
            ? note.childNotes.map((cnote) => ({
                id: cnote.cnoteId,
                assetId: cnote.cassetId,
                assets: cnote.cattachments,
                avatarUrl: cnote.cavatarUrl,
                date: cnote.cdate,
                notes: cnote.cnotes,
                parentNoteId: cnote.cparentNoteId,
                userId: cnote.cuserId,
                userName: cnote.cuserName,
            }))
            : [],
    }));
};
exports.notesMapper = notesMapper;
const handleRequestAPI = (messages = {
    loading: 'Loading...',
}, payload, onDone = null, onFail = null, method = 'get') => {
    utilities_1.default.blockPage(messages.loading || 'Loading...');
    utilities_1.default
        .fetch(exports.URLS.api, payload, method)
        .done((res) => {
        utilities_1.default.unblockPage();
        if ((0, lodash_1.isFunction)(onDone)) {
            onDone(res);
        }
        if (messages.success) {
            utilities_1.default.dismissNotifications();
            utilities_1.default.notification.success(messages.success);
        }
    })
        .fail((error) => {
        utilities_1.default.unblockPage();
        if ((0, lodash_1.isFunction)(onFail)) {
            onFail(error);
        }
        if (messages.fail) {
            utilities_1.default.dismissNotifications();
            utilities_1.default.notification.danger(messages.fail);
        }
    });
};
exports.handleRequestAPI = handleRequestAPI;
const handleUploadAttachment = async (file, jobid, dirId, requirementid = '', tempTicketId = '', description = '') => {
    const { preview, name, size } = file;
    const qquuid = preview === null || preview === void 0 ? void 0 : preview.replace(`blob:${exports.URLS.pulse}`, '');
    const formData = new FormData();
    const formDataPayload = {
        jobid,
        qquuid,
        ndirid: dirId,
        qqfilename: name,
        requirementid,
        tempTicketId,
        description,
        qqfile: file,
        qqtotalfilesize: size,
    };
    Object.keys(formDataPayload).forEach((attr) => {
        formData.append(attr, formDataPayload[attr]);
    });
    const deferred = jquery_1.default.Deferred();
    jquery_1.default.ajax({
        method: 'POST',
        url: `${exports.URLS.pulse}requirements.php?action=chunked-file-upload`,
        data: formData,
        async: true,
        contentType: false,
        processData: false,
    })
        .done((res) => {
        deferred.resolve(JSON.parse(res));
    })
        .fail((error) => {
        deferred.reject(error);
    });
    return deferred;
};
exports.handleUploadAttachment = handleUploadAttachment;
const getAssetDetailResponse = (response) => {
    var _a;
    const isWorkflow = ((_a = response.included) === null || _a === void 0 ? void 0 : _a.some((include) => include.type === 'workflows')) || false;
    const parsedData = (0, utilities_1.parseJsonApi)(response);
    if (Array.isArray(parsedData)) {
        return parsedData.map((data) => (0, exports.parseAssetDetailResponse)(data, isWorkflow));
    }
    return (0, exports.parseAssetDetailResponse)(parsedData, isWorkflow);
};
exports.getAssetDetailResponse = getAssetDetailResponse;
const parseAssetDetailResponse = (parsedData, isWorkflow = false) => {
    var _a, _b, _c, _d, _e;
    const { asset_id, key_document, total_downloads, assetPermission = [], 'asset-detail': assetDetail = {}, 'doc-type': docType = {}, 'asset-workflow-approvals': assetWorkflowApprovals = [], 'asset-meta-data': assetMeta = {}, 'generated-preview-pdf': generatedPreviewPdf = null, requirement, meta = {}, tags, time, invoice = {}, 'airing-country': airingCountry, workflows, ...restResponse } = parsedData;
    const formattedTags = tags.length
        ? tags.map((tag) => ({ label: tag.name, value: tag.id }))
        : [];
    const formattedTime = (0, moment_1.default)(time).format('MM-DD-YYYY hh:mm');
    const { asset_origin: assetOrigin, language, format, 'media-channel': mediaChannel, program, length_dimension: lengthDimension, ...restAssetDetail } = assetDetail || {};
    const formattedAssetDetail = {
        assetOrigin,
        language: {
            id: language === null || language === void 0 ? void 0 : language.language_id,
            name: language === null || language === void 0 ? void 0 : language.name,
        },
        format: {
            id: format === null || format === void 0 ? void 0 : format.asset_format_id,
            name: format === null || format === void 0 ? void 0 : format.name,
        },
        mediaChannel: {
            id: mediaChannel === null || mediaChannel === void 0 ? void 0 : mediaChannel.media_channel_id,
            name: mediaChannel === null || mediaChannel === void 0 ? void 0 : mediaChannel.name,
        },
        program: {
            id: program === null || program === void 0 ? void 0 : program.program_id,
            name: program === null || program === void 0 ? void 0 : program.name,
        },
        lengthDimension,
        ...restAssetDetail,
    };
    const formattedDocType = {
        id: docType === null || docType === void 0 ? void 0 : docType.doc_type_id,
        name: docType === null || docType === void 0 ? void 0 : docType.name,
    };
    const formattedAssetWorkflowApprovals = assetWorkflowApprovals.map(({ step_completed: stepCompleted, ...restWorkflow }) => ({
        stepCompleted,
        ...restWorkflow,
    }));
    const formattedMeta = {
        assetsMovedTotal: meta === null || meta === void 0 ? void 0 : meta.assets_moved_total,
        subFoldersMovedTotal: meta === null || meta === void 0 ? void 0 : meta.sub_folders_moved_total,
    };
    const formattedAssetMeta = {
        metaDataId: assetMeta === null || assetMeta === void 0 ? void 0 : assetMeta.meta_data_id,
        dataValue: assetMeta === null || assetMeta === void 0 ? void 0 : assetMeta.data_value,
    };
    const formattedGeneratedPreviewPdf = generatedPreviewPdf
        ? {
            id: generatedPreviewPdf.id,
            assetid: generatedPreviewPdf.assetid,
            status: generatedPreviewPdf.status,
            attempts: generatedPreviewPdf.attempts,
            converterFamily: generatedPreviewPdf.converter_family,
            converterBackend: generatedPreviewPdf.converter_backend,
            sourceAssetUpdatedAt: generatedPreviewPdf.source_asset_updated_at,
            sourceAssetSize: generatedPreviewPdf.source_asset_size,
            fileSize: generatedPreviewPdf.file_size,
            queuedAt: generatedPreviewPdf.queued_at,
            processingAt: generatedPreviewPdf.processing_at,
            completedAt: generatedPreviewPdf.completed_at,
            failedAt: generatedPreviewPdf.failed_at,
            skipReason: generatedPreviewPdf.skip_reason,
            errorCode: generatedPreviewPdf.error_code,
            errorMessage: generatedPreviewPdf.error_message,
            reasonCode: generatedPreviewPdf.reason_code,
            messageKey: generatedPreviewPdf.message_key,
            retryAfter: generatedPreviewPdf.retry_after,
        }
        : null;
    const { 'invoice-tax-rate': invoiceTaxRate = {}, ...restInvoice } = invoice || {};
    const { tax_rate_name: taxRateName, ...restInvoiceTaxRate } = invoiceTaxRate || {};
    const formattedInvoice = invoice && {
        invoiceId: invoice === null || invoice === void 0 ? void 0 : invoice.id,
        createdAt: invoice === null || invoice === void 0 ? void 0 : invoice.created_at,
        invoiceNumber: invoice === null || invoice === void 0 ? void 0 : invoice.invoice_number,
        currencyCode: invoice === null || invoice === void 0 ? void 0 : invoice.currency_code,
        dueDate: invoice === null || invoice === void 0 ? void 0 : invoice.due_date,
        agressoPONumber: invoice === null || invoice === void 0 ? void 0 : invoice.agresso_po_number,
        agressoInvoiceNumber: invoice === null || invoice === void 0 ? void 0 : invoice.agresso_invoice_number,
        invoiceTaxRate: {
            taxRateName,
            ...restInvoiceTaxRate,
        },
        ...restInvoice,
    };
    const { job = {}, ...formattedRequirement } = requirement || {};
    const { brand, client, ...restJob } = job || {};
    const formattedJob = {
        ...restJob,
        airingCountry: restJob['airing-country'],
    };
    /** Normalising the data to match formOptions.workflow */
    if ((_c = (_b = (_a = restResponse === null || restResponse === void 0 ? void 0 : restResponse.note) === null || _a === void 0 ? void 0 : _a.ticket) === null || _b === void 0 ? void 0 : _b.workflow) === null || _c === void 0 ? void 0 : _c.name) {
        restResponse.note.ticket.workflow.title =
            restResponse.note.ticket.workflow.name;
        delete restResponse.note.ticket.workflow.name;
    }
    return {
        isWorkflow,
        assetId: asset_id,
        dirId: (_d = requirement === null || requirement === void 0 ? void 0 : requirement.directory) === null || _d === void 0 ? void 0 : _d.id,
        dirName: (_e = requirement === null || requirement === void 0 ? void 0 : requirement.directory) === null || _e === void 0 ? void 0 : _e.title,
        keyDocument: key_document,
        totalDownloads: total_downloads,
        tags: formattedTags,
        uploadedDate: formattedTime,
        assetDetail: formattedAssetDetail,
        generatedPreviewPdf: formattedGeneratedPreviewPdf,
        docType: formattedDocType,
        assetWorkflowApprovals: formattedAssetWorkflowApprovals,
        meta: formattedMeta,
        assetMeta: formattedAssetMeta,
        invoice: formattedInvoice,
        job: formattedJob,
        requirement: formattedRequirement,
        brand,
        client,
        assetPermission,
        airingCountry,
        ...restResponse,
    };
};
exports.parseAssetDetailResponse = parseAssetDetailResponse;
const buildAssetPdfPreviewUrl = (assetId) => `${window.pulse.config.urls.pulse}open.php?assetid=${assetId}&action=download&format=pdf&isViewOnBrowser=true`;
exports.buildAssetPdfPreviewUrl = buildAssetPdfPreviewUrl;
const getAssetStatusColor = (status) => {
    if (!status)
        return '';
    return ['approved', 'approved for release'].includes(status.trim().toLowerCase())
        ? '#53a92c'
        : 'FFC20E';
};
exports.getAssetStatusColor = getAssetStatusColor;
const sendViaWebSocket = (data) => {
    if ('WebSocket' in window) {
        const ws = new WebSocket('ws://localhost:6275');
        ws.onopen = function () {
            ws.send(data);
        };
        ws.onmessage = function (evt) {
            const received_msg = evt.data;
            // @ts-ignore
            mjavaStatus = true;
        };
        ws.onclose = function () { };
    }
    else {
        alert('WebSocket NOT supported by your Browser!');
    }
};
/**
 * Check to see if java app is installed
 * @returns {Promise<boolean>}
 */
const javaStatus = () => {
    return new Promise((resolve, reject) => {
        // launch java editor
        if ('WebSocket' in window) {
            // Let us open a web socket
            const ws = new WebSocket('ws://localhost:6275');
            ws.onopen = () => {
                // Web Socket is connected, send data using send()
                ws.send('assetid');
            };
            ws.onmessage = () => {
                resolve(true);
            };
            ws.onerror = () => {
                resolve(false);
            };
        }
        else {
            // The browser doesn't support WebSocket
            reject(new Error('WebSocket NOT supported by your Browser!'));
        }
    });
};
const handleUploadNewVersion = (asset) => {
    const { dirId, requirementId } = asset;
    window.location.href = `${exports.URLS.app}passport/${exports.JOB_ID}/files/${dirId}/upload/${requirementId}`;
};
exports.handleUploadNewVersion = handleUploadNewVersion;
const handleAddToCollection = (asset, onSuccess) => {
    const { assetId } = asset;
    jquery_1.default.confirm({
        title: 'Add to collection',
        content: '<div id="add-to-collection" class="add-to-collection"><h4 id="collection-loader" class="uk-text-center"><span uk-spinner="ratio:0.6"></span><br /> Loading collections</h4></div>',
        confirmButtonClass: 'btn-green btn',
        cancelButtonClass: 'btn-outline uk-hidden',
        confirmButton: 'Assign to collection',
        cancelButton: 'Cancel',
        animation: 'opacity',
        closeIcon: true,
        onOpen() {
            const addToCollectionEl = (0, jquery_1.default)('#add-to-collection');
            (0, jquery_1.default)('<select>', {
                id: 'collection-list',
                class: 'uk-hidden',
            })
                .appendTo(addToCollectionEl)
                .append('<option value="0">Choose Collection</option>')
                .append('<option value="new-collection">+ New Collection</option>');
            (0, jquery_1.default)('<input />', {
                id: 'new-collection-input',
                class: 'hide',
                placeholder: 'Enter name of new collection',
            }).appendTo(addToCollectionEl);
            jquery_1.default.get(`${exports.URLS.pulse}dam.php`, {
                action: 'get-collections',
            })
                .done((data) => {
                jquery_1.default.each(JSON.parse(data), (i, collection) => {
                    (0, jquery_1.default)('#collection-list').append(`<option value="${collection.collectionid}">${collection.name}</option>`);
                });
                (0, jquery_1.default)('#collection-loader').hide();
                (0, jquery_1.default)('#add-to-collection select').removeClass('uk-hidden');
            })
                .fail(() => {
                (0, jquery_1.default)('#collection-loader').hide();
                (0, jquery_1.default)('#add-to-collection select').removeClass('uk-hidden');
            });
        },
        confirm() {
            utilities_1.default.blockPage();
            let collectionId = (0, jquery_1.default)('#collection-list').val();
            if (collectionId === 0) {
                utilities_1.default.unblockPage();
                jquery_1.default.alert({
                    title: 'Warning',
                    content: 'Please choose a collection',
                    confirmButtonClass: 'btn-outline',
                    cancelButtonClass: 'btn-outline',
                    confirmButton: 'Close',
                    cancelButton: 'Cancel',
                    animation: 'opacity',
                });
                return;
            }
            if (collectionId === 'new-collection') {
                const collectionName = (0, jquery_1.default)('#new-collection-input').val();
                if (collectionName === '') {
                    utilities_1.default.unblockPage();
                    jquery_1.default.alert({
                        title: 'Warning',
                        content: 'You must provide a name for the collection',
                        confirmButtonClass: 'btn-outline',
                        cancelButtonClass: 'btn-outline',
                        confirmButton: 'Close',
                        cancelButton: 'Cancel',
                        animation: 'opacity',
                    });
                    return;
                }
                const saveCollectionParams = {
                    action: 'collection_save',
                    collectionName,
                    collectionAccess: 4,
                    returnID: 1, // Return the id on creation
                };
                jquery_1.default.post(`${exports.URLS.pulse}/gallery.php`, saveCollectionParams)
                    .done((resp) => {
                    collectionId = resp;
                })
                    .always(() => {
                    utilities_1.default.unblockPage();
                });
            }
            const params = {
                action: 'update_collection',
                collectionid: collectionId,
                assetid: assetId,
                view: 'collection',
            };
            jquery_1.default.post(`${exports.URLS.pulse}/gallery.php`, params)
                .done(() => {
                utilities_1.default.dismissNotifications();
                utilities_1.default.notification.success('Added to collection');
            })
                .fail(() => {
                utilities_1.default.dismissNotifications();
                utilities_1.default.notification.danger('Failed to add to collection');
            })
                .always(() => {
                utilities_1.default.unblockPage();
            });
            onSuccess();
        },
    });
};
exports.handleAddToCollection = handleAddToCollection;
const handleApproveFile = (asset) => {
    const { assetId, requirementId, dirId } = asset;
    const openUrl = `${exports.URLS.pulse}notes.php?action=feedback&assetid=${assetId}&requirementid=${requirementId}&jobid=${exports.JOB_ID}&dirid=${dirId}&nstatus=approve&window=approve&skipReload=y`;
    window.open(openUrl, 'Edit workflow', 'width=680,height=600,scrollbars=1');
};
exports.handleApproveFile = handleApproveFile;
const handleApproveFileForRelease = (asset, onSuccess) => {
    const { assetId } = asset;
    const payload = {
        action: 'files',
        type: 'approveForRelease',
        assetId,
    };
    (0, exports.handleRequestAPI)({}, payload, (data) => {
        if (data === 'select-status') {
            utilities_1.default.notification.success('This file is already Approved For Release');
        }
        else {
            utilities_1.default.notification.success('The file is approved for release');
            onSuccess();
        }
    }, (e) => {
        utilities_1.default.notification.danger(`Unable to approve this file for release<br>${e.errors.errors}`);
    });
};
exports.handleApproveFileForRelease = handleApproveFileForRelease;
const handleEnablePublicLink = (asset) => {
    const { assetId } = asset;
    const payload = {
        action: 'files',
        type: 'public',
        assetId,
        s: '',
    };
    (0, exports.handleRequestAPI)({}, payload, (data) => {
        jquery_1.default.dialog({
            title: 'Public link',
            content: '<div id="public-link"></div>',
            cancelButtonClass: 'btn-outline',
            confirmButton: 'Close',
            columnClass: 'wider',
            onOpen() {
                (0, jquery_1.default)('#public-link').loadFromTemplate({
                    template: 'enable-public-link',
                    extension: '.html',
                    path: `${exports.URLS.app_resources}/templates/passport/files/`,
                    data: {
                        urls: exports.URLS,
                        openUrl: data.link,
                    },
                    render_method: 'html',
                    callback() { },
                });
            },
        });
    }, (e) => {
        utilities_1.default.notification.danger(`Unable to enable public link<br>${e.errors.errors}`);
    });
};
exports.handleEnablePublicLink = handleEnablePublicLink;
const handleCheckout = (asset, onSuccess) => {
    const { assetId } = asset;
    jquery_1.default.confirm({
        title: 'Check Out File',
        content: '<h4>Are you sure you want to check this out?</h4>',
        cancelButtonClass: 'btn-outline',
        cancelButton: 'Cancel',
        confirmButton: 'Check out',
        confirmButtonClass: 'btn-green',
        confirm() {
            const payload = {
                action: 'files',
                type: 'checkout',
                assetId,
            };
            (0, exports.handleRequestAPI)({
                loading: 'Loading',
                success: 'File checked out successfully.',
                fail: 'Failed to check out file, please try again.',
            }, payload, onSuccess);
        },
    });
};
exports.handleCheckout = handleCheckout;
const handleCopyFile = (asset, onSuccess) => {
    const { assetId } = asset;
    jquery_1.default.confirm({
        title: 'Copy to folder',
        content: '<div id="copy-to-folder"><h4 id="folder-loader" class="uk-text-center">Loading folders</h4></div>',
        confirmButtonClass: 'btn-green btn',
        cancelButtonClass: 'btn-outline',
        confirmButton: 'Confirm',
        animation: 'scale',
        closeAnimation: 'opacity',
        onOpen() {
            const copyToFolder = (0, jquery_1.default)('#copy-to-folder');
            (0, jquery_1.default)('<select>', {
                id: 'folder-list',
                class: 'uk-hidden',
            })
                .appendTo(copyToFolder)
                .append('<option value="0">Choose Folder</option>');
            (0, exports.handleRequestAPI)({}, {
                action: 'folders',
                jobId: exports.JOB_ID,
            }, (data) => {
                jquery_1.default.each(data.directories, (i, folder) => {
                    (0, jquery_1.default)('#folder-list').append(`<option value="${folder.dirId}">${folder.directoryName}</option>`);
                });
                (0, jquery_1.default)('#folder-loader').hide();
                (0, jquery_1.default)('#copy-to-folder select').removeClass('uk-hidden');
            }, () => {
                (0, jquery_1.default)('#folder-loader').hide();
                (0, jquery_1.default)('#copy-to-folder select').removeClass('uk-hidden');
            });
        },
        confirm() {
            const copyFolderId = (0, jquery_1.default)('#folder-list').val();
            if (copyFolderId === 0) {
                utilities_1.default.unblockPage();
                jquery_1.default.alert({
                    title: 'Warning',
                    content: 'Please choose a folder',
                    confirmButtonClass: 'btn-outline',
                    cancelButtonClass: 'btn-outline',
                    confirmButton: 'Close',
                    cancelButton: 'Cancel',
                    animation: 'opacity',
                });
                return;
            }
            jquery_1.default.post(`${exports.URLS.pulse}/ajax.php`, {
                action: 'copyFileToFolder',
                assetId,
                jobId: exports.JOB_ID,
                format: 'json',
                copyFolderId,
            })
                .done(() => {
                utilities_1.default.notification.success('Asset copied');
            })
                .fail(() => {
                utilities_1.default.notification.danger('Failed to copy asset');
            });
            onSuccess();
        },
    });
};
exports.handleCopyFile = handleCopyFile;
const handleOpenInOfficeOnline = (asset) => {
    const { assetId } = asset;
    const wopiApiUrl = `${exports.URLS.app}wopi/${assetId}`;
    utilities_1.default.blockPage();
    utilities_1.default
        .fetch(wopiApiUrl)
        .done((data) => {
        if (data.access_token) {
            window.open(`${exports.URLS.app}oos/files/${assetId}?access_token=${data.access_token}&action=load`);
        }
        else {
            utilities_1.default.dismissNotifications();
            utilities_1.default.notification.danger('Failed to start office online session');
        }
    })
        .fail(() => {
        utilities_1.default.dismissNotifications();
        utilities_1.default.notification.danger('Failed to get office online token');
    })
        .always(() => {
        utilities_1.default.unblockPage();
    });
};
exports.handleOpenInOfficeOnline = handleOpenInOfficeOnline;
const handleDesktopEdit = (asset) => {
    const { assetId, dirId, title } = asset;
    const isMac = navigator.platform.toUpperCase().indexOf('MAC') !== -1;
    const isWindows = navigator.platform.toUpperCase().indexOf('WIN') !== -1;
    // check to see if java app is installed
    javaStatus()
        .then((mjavaStatus) => {
        if (mjavaStatus) {
            // build URL for Local Java Editor
            // window.location.href = `pulse://${window.location.hostname}?jobid=${JOB_ID}&dirid=${dirId}&assetid=${assetId}&title=${title}`;
            sendViaWebSocket(`pulse://${window.location.hostname}?jobid=${exports.JOB_ID}&dirid=${dirId}&assetid=${assetId}&title=${title}`);
            return false;
        }
        const payload = {
            action: 'files',
            type: 'desktopEdit',
            // eslint-disable-next-line no-nested-ternary
            os: isMac ? 'mac' : isWindows ? 'windows' : '',
        };
        (0, exports.handleRequestAPI)({
            fail: 'Failed to load requested information, please try again',
        }, payload, (data) => {
            jquery_1.default.dialog({
                title: 'Desktop Edit',
                content: '<div id="desktop-edit"></div>',
                cancelButtonClass: 'btn-outline',
                confirmButton: 'Close',
                columnClass: 'wider',
                onOpen() {
                    (0, jquery_1.default)('#desktop-edit').loadFromTemplate({
                        template: 'desktop-edit',
                        extension: '.html',
                        path: `${exports.URLS.app_resources}/templates/passport/files/`,
                        data: {
                            downloads: data,
                        },
                        render_method: 'html',
                        callback() { },
                    });
                },
            });
        });
        return true;
    })
        .catch((err) => () => {
        utilities_1.default.dismissNotifications();
        utilities_1.default.notification.danger(err.message);
    });
};
exports.handleDesktopEdit = handleDesktopEdit;
const handleDeleteFile = (asset, onSuccess) => {
    const { assetId } = asset;
    jquery_1.default.confirm({
        title: 'Delete file',
        content: '<h4>Are you sure you want to delete this file?</h4><p class="alert alert-notice"><strong>Warning : </strong> This action can not be undone.</p>',
        cancelButtonClass: 'btn-outline uk-hidden',
        cancelButton: 'Cancel',
        confirmButton: 'Delete',
        confirmButtonClass: 'btn-green',
        closeIcon: true,
        confirm() {
            const payload = {
                action: 'files',
                type: 'delete',
                jobId: exports.JOB_ID,
                assetId,
            };
            (0, exports.handleRequestAPI)({
                loading: 'Loading',
                success: 'The file has been deleted',
                fail: 'There was an error deleting this file. <br />Please try again',
            }, payload, onSuccess, () => {
                utilities_1.default.notification.danger('Failed to load requested information, please try again.');
            });
        },
    });
};
exports.handleDeleteFile = handleDeleteFile;
const getPriorityDataSubmission = (priorityId) => {
    if (priorityId !== PRIORITY.escalated) {
        return {
            id: PRIORITY.escalated,
            title: 'escalated',
            color: '',
        };
    }
    return {
        id: PRIORITY.deescalated,
        title: 'de-escalated',
        color: '',
    };
};
exports.getPriorityDataSubmission = getPriorityDataSubmission;
const handleOpenFile = (assetId, tippyInstance) => {
    tippyInstance.hide();
    const openAssetURL = `${exports.URLS.pulse}open.php?assetid=${assetId}&count=true`;
    window.open(openAssetURL, `${assetId}`);
};
exports.handleOpenFile = handleOpenFile;
const handleDownloadFile = (assetId) => {
    window.open(`${exports.URLS.pulse}open.php?action=download&assetid=${assetId}`);
};
exports.handleDownloadFile = handleDownloadFile;
const handleGoToFolder = (assetId, dirId, jobId) => {
    window.location.href = `${exports.URLS.app}passport/${jobId}/files/${dirId}#${assetId}`;
};
exports.handleGoToFolder = handleGoToFolder;
const isJde = (asset) => {
    var _a, _b;
    return ((_b = (_a = asset === null || asset === void 0 ? void 0 : asset.brand) === null || _a === void 0 ? void 0 : _a.category) === null || _b === void 0 ? void 0 : _b.brand_category_id) === exports.JDE_BRAND_CATEGORY_ID;
};
exports.isJde = isJde;
const deleteWithConfirmation = (dispatch, deleteToDispatch) => {
    jquery_1.default.confirm({
        title: 'Remove Tag',
        content: '<h4>Are you sure you want to remove this tag?</h4>',
        confirmButtonClass: 'btn-green btn',
        cancelButtonClass: 'btn-outline uk-hidden',
        confirmButton: 'Remove tag',
        cancelButton: 'Cancel',
        closeIcon: true,
        confirm: () => {
            dispatch(deleteToDispatch);
        },
    });
};
exports.deleteWithConfirmation = deleteWithConfirmation;
const useReviewIdByDeepLinks = (hash) => {
    const splitReview = hash.replace(/#/, '').split('-');
    return [Number(splitReview[0] || 0), Number(splitReview[1] || 0)];
};
exports.useReviewIdByDeepLinks = useReviewIdByDeepLinks;
